import { useEffect } from 'react';

import { useAppDispatch } from '../../../../store/hooks';
import { ReleaseModel } from '../../models/release.model';
import { appsFilesActions } from '../../store/slices/apps-files.slice';

export const useSetApkFiles = (data?: ReleaseModel) => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (data) {
      data.apkFiles.forEach(file => {
        dispatch(appsFilesActions.setApk(file));
      });
    }

    return () => {
      dispatch(appsFilesActions.resetAppsFilesState());
    };
  }, []);
};
